import axios from "axios";

function getHeaders() {
  return {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${localStorage.getItem("token")}`, // Assumes token is stored in localStorage
    },
  };
}

export const postReminder = async (data) => {
  try {
    const response = await axios.post(
      `${process.env.REACT_APP_BASE_URL}/user/schedule-reminder/`,
      data,
      getHeaders()
    );
    return response;
  } catch (err) {
    console.error(err);
  }
};
export const getReminders = async () => {
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_BASE_URL}/user/reminders/`,
      getHeaders()
    );

    return response.data;
  } catch (err) {
    if (err.response && err.response.status === 404) {
      return [];
    }
    console.error("Error fetching reminder:", err);
    throw err;
  }
};
export const getSpecificUserReminders = async (id) => {
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_BASE_URL}/lead/leads-reminders/${id}/`,
      getHeaders()
    );

    return response.data;
  } catch (err) {
    if (err.response && err.response.status === 404) {
      return [];
    }
    console.error("Error fetching reminder:", err);
    throw err;
  }
};

export const careateUserReminder = async (data) => {
  try {
    const response = await axios.post(
      `${process.env.REACT_APP_BASE_URL}/lead/leads-reminders/`,
      data,
      getHeaders()
    );

    return response.data;
  } catch (err) {
    console.error(err);
  }
};
export const updateUserReminder = async (id, data) => {
  try {
    const response = await axios.patch(
      `${process.env.REACT_APP_BASE_URL}/lead/leads-reminders/${id}/`,
      data,
      getHeaders()
    );

    return response.data;
  } catch (err) {
    console.error(err);
  }
};

export const deleteSpecificReminder = async (id) => {
  try {
    const response = await axios.delete(
      `${process.env.REACT_APP_BASE_URL}/lead/leads-reminders/${id}/`,
      getHeaders() // Assumes getHeaders() returns necessary headers
    );

    return response; // Return response data if needed
  } catch (err) {
    console.error("Error fetching reminder:", err);
    throw err; // Rethrow the error for further handling if necessary
  }
};
